import { IProvince, IWard } from '~/utils/interface/location';
import axiosClient from './axiosClient';

const locationApi = {
  getListProvinces() {
    const url = `/api/location/provinces`;
    return axiosClient.get<IProvince[]>(url);
  },

  getListWards(params: { province: string }) {
    const url = `/api/location/wards`;
    return axiosClient.get<IWard[]>(url, { params });
  },
};

export default locationApi;
